import { render, staticRenderFns } from "./questionList.vue?vue&type=template&id=2dce7b12&scoped=true"
import script from "./questionList.vue?vue&type=script&lang=js"
export * from "./questionList.vue?vue&type=script&lang=js"
import style0 from "./questionList.vue?vue&type=style&index=0&id=2dce7b12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dce7b12",
  null
  
)

export default component.exports